import type { ModuleTagEntry } from './index';

/** Radiopharmaceutical Information module tags. */
export const tags: ModuleTagEntry[] = [
  'RadiopharmaceuticalStartTime',
  'RadiopharmaceuticalStopTime',
  'RadionuclideTotalDose',
  'RadionuclideHalfLife',
];
